<div
  *ngIf="!!(countdown$ | async)?.isOpen"
  [ngClass]="{
    'c-text-sm': true,
    countdown: true,
    expires: (countdown$ | async)?.isExpiring,
    retail: !isCompetitive && (countdown$ | async)?.type === 'Retail',
    all: !isCompetitive && (countdown$ | async)?.type === 'All',
    institutional:
      !isCompetitive && (countdown$ | async)?.type === 'Institutional'
  }"
  [attr.data-tooltip]="countdown$ | async | orderPeriodHoverText"
  [attr.data-tooltip-conf]="'left'"
  [attr.data-automation-e2e-selector]="'muni-deal-monitor-order-period'"
>
  <i
    *ngIf="!!(countdown$ | async)?.countdown"
    [ngClass]="{
      fa: true,
      'fa-clock-o': true,
      icon: true
    }"
    data-icon
  ></i>
  <span class="order-period-text">{{
    orderType$ | async | orderPeriodType
  }}</span>
  <span class="order-period-text">{{
    (countdown$ | async)?.countdown | orderPeriodCountdown: getDealType
  }}</span>
</div>
<ng-content *ngIf="!!(countdown$ | async)?.isOpen"></ng-content>
